import React from 'react';
import styles from './DialogStyles.module.scss';
import { DialogActions } from '@material-ui/core';

export default function DialogFooter({ children }) {
  return <DialogActions classes={{ root: styles.popupControls }}>{children}</DialogActions>;
}
